export enum DropdownLabel {
	categoryLabel = 'categoryLabel',
	subcategoryLabel = 'subcategoryLabel',
	legalFormLabel = 'legalFormLabel',
	groupLabel = 'groupLabel',
}
